// extracted by mini-css-extract-plugin
export default {"container":"image_container__eRKbB","img":"image_img__9WQdW"};